import { Provider } from 'react-redux';
import { LayoutBuilder } from '~/rage/utils';
import { Layouts } from '~/shared';
import { store } from './redux/store';
import { PromoLayout } from './views/Promo';

const LayoutComponent = () => (
	<Provider store={store}>
		<PromoLayout />
	</Provider>
);

const Layout = new LayoutBuilder(LayoutComponent)
	.setDisplayName(Layouts.Promo)
	.setHudVisible(true)
	.build();

export default Layout;
